"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RibbonButtonItem = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var RibbonButtonItem = (function (_super) {
    tslib_1.__extends(RibbonButtonItem, _super);
    function RibbonButtonItem(id, text, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, id, options.beginGroup) || this;
        _this.type = base_1.RibbonItemType.Button;
        _this.text = text;
        _this.icon = options.icon;
        _this.localizationId = options.localizationId;
        _this.showText = options.showText === undefined ? false : options.showText;
        _this.toggleMode = options.toggleMode === undefined ? false : options.toggleMode;
        _this.selected = options.selected === undefined ? false : options.selected;
        return _this;
    }
    return RibbonButtonItem;
}(base_1.RibbonItemBase));
exports.RibbonButtonItem = RibbonButtonItem;
